module.exports = __webpack_public_path__ + "static/media/compendio-celular.265075a1.png";